import React, { FC } from 'react';
import { useSeo } from 'hooks/use-seo';
import { ProductForSearchInterface } from 'modules/search/interfaces/product-for-search.interface';
import { getProductStructuralData } from 'helpers/get-product-structural-data';

interface SearchStructuredDataProps {
    title: string;
    page: number;
    products: ProductForSearchInterface;
    pageLimit: number;
}

const SearchStructuredData: FC<SearchStructuredDataProps> = ({ title, products, page, pageLimit }) => {
    const seo = useSeo();
    const searchResultPageStructuredData = {
        '@type': 'SearchResultPage',
        '@id': seo.canonical,
        'url': seo.canonical,
        'name': title,
        'description': seo.description,
        'isPartOf': {
            '@id': 'https://www.skapiec.pl/#/schema/WebSite/1'
        },
        'breadcrumb': {
            '@id': `https://www.skapiec.pl/#/schema/BreadcrumbList${seo.og?.url}`
        },
        'mainEntity': {
            '@type': 'ItemList',
            'numberOfItems': products.count,
            'itemListElement': products.items.map((item, index) => {
                const itemCount = ((page - 1) * pageLimit) + index + 1;

                return {
                    '@type': 'ListItem',
                    'position': String(itemCount),
                    'item': getProductStructuralData(item)
                };
            })
        }
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(searchResultPageStructuredData) }}
        />
    );
};

export default SearchStructuredData;
